module.exports = __webpack_public_path__ + "static/media/icons8-opened-folder.bb75b27f.svg";